var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"cta-banner"},[_c('div',{staticClass:"container cta-banner__container"},[_c('p',{staticClass:"cta-banner__copy"},[_vm._v(_vm._s(_vm.copy))]),_c('AppButton',{attrs:{"text":_vm.buttonText,"link":_vm.buttonLink}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }